export function fieldValueIsSet(value: string | boolean | string[]): boolean {
    if (Array.isArray(value)) return value.length > 0
    else if (typeof value === 'string') return value.length > 0
    else return true
}
